export default __webpack_public_path__ + "static/media/feathers.e9cddfbc.jpeg";